module.exports = __webpack_public_path__ + "img/设计便利.b6611cf4.png";